import {
  getItemOrDefaultToValue,
  getPhoneNumber,
  getPersonName,
  getCountryName,
} from 'utils/details';
import { SECURITY_COMPANY_APPROVAL_STATUS } from '../../constants/securityCompany';

export const transform = (securityCompany, countryList) => {
  return {
    generalInfo: {
      name: {
        type: 'text',
        value: getItemOrDefaultToValue(securityCompany, 'name'),
      },
      country: {
        type: 'text',
        value: getCountryName(securityCompany.country, countryList),
      },
      industry: {
        type: 'text',
        value: getItemOrDefaultToValue(securityCompany, 'industry'),
      },
      operationsPhone: {
        type: 'text',
        value: getPhoneNumber(
          getItemOrDefaultToValue(securityCompany, 'operationsPhoneNumber'),
        ),
      },
      bookingPhone: {
        type: 'text',
        value: getPhoneNumber(
          getItemOrDefaultToValue(securityCompany, 'bookingPhoneNumber'),
        ),
      },
      address: {
        type: 'text',
        value: getItemOrDefaultToValue(securityCompany, 'address'),
      },
    },
    detailedInfo: {
      accountHolder: {
        type: 'array',
        value: [
          { display: getPersonName(securityCompany.manager) },
          {
            display: getItemOrDefaultToValue(
              securityCompany.manager,
              'email',
              '-',
            ),
          },
        ],
      },
    },
    others: {
      id: { value: securityCompany.id },
      status: {
        value: SECURITY_COMPANY_APPROVAL_STATUS[securityCompany.status],
      },
    },
  };
};
